/**
 * Format a Nominatim address object into a clean, readable string.
 * Returns: "house_number Street, Suburb, State, Postcode, Country"
 * Omits city/council/county to keep it short and clean.
 */
export const NOMINATIM_BASE = (process.env.REACT_APP_NOMINATIM_URL || '/nominatim').replace(/\/$/, '');

export function formatNominatimAddress(address) {
  if (!address) return '';
  const parts = [];

  // Street number + name
  const street = [address.house_number, address.road].filter(Boolean).join(' ');
  if (street) parts.push(street);

  // Suburb (use suburb, or village, or town — but NOT city)
  const suburb = address.suburb || address.village || address.town || address.hamlet;
  if (suburb) parts.push(suburb);

  // State
  if (address.state) parts.push(address.state);

  // Postcode
  if (address.postcode) parts.push(address.postcode);

  // Country
  if (address.country) parts.push(address.country);

  return parts.join(', ');
}

/**
 * Reverse geocode using self-hosted Nominatim and return a clean address string.
 * Falls back to display_name if address parsing fails.
 */
export async function reverseGeocodeClean(lat, lng) {
  try {
    const resp = await fetch(
      `${NOMINATIM_BASE}/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`
    );
    const data = await resp.json();
    const clean = formatNominatimAddress(data.address);
    return clean || data.display_name || '';
  } catch {
    return '';
  }
}
